import Axios from "../../Config/API";
import {
    IBloco,
    ICadastrarFormularioProduto,
    ICadastrarPerguntaFormularioProduto,
    ICadastrarProduto,
    ICadastrarRespostaFormularioProduto,
    IClassificacaoProduto,
    IEmpreendimento,
    IProduto,
    IProdutosArvore,
    IResponderFormularioProduto,
    IUnidade,
} from "../../../Interfaces/Geral/Produtos/ProdutosInterface";
import Service from "../../Service";

export async function ListarEmpreendimentosService(
    comObra?: boolean,
    pesquisa?: string
) {
    return Service(
        Axios.get<Array<IEmpreendimento>>(
            `/home/produtos/listarempreendimentos?comObra=${
                comObra ? "true" : "false"
            }&pesquisa=${pesquisa ?? ""}`
        )
    );
}

// export async function ListarEmpreendimentosService(
//     comObra?: boolean,
//     pesquisa?: string
// ) {
//     const response = await Axios.get<Array<IEmpreendimento>>(
//         `/home/produtos/listarempreendimentos?comObra=${
//             comObra ? "true" : "false"
//         }&pesquisa=${pesquisa}`
//     )
//         .then((response) => {
//             return response;
//         })
//         .catch((err) => {
//             throw err.response;
//         });
//     return response;
// }

export async function ListarProdutosService(idEmpreendimento: number) {
    const response = await Axios.get<Array<IProduto>>(
        `/home/produtos/listarprodutos?idEmpreendimento=${idEmpreendimento}`
    )
        .then((response) => {
            return response;
        })
        .catch((err) => {
            throw err.response;
        });
    return response;
}

export async function ListarProdutosPorEmpreendimentosService(requestBody: {
    ID_EMPREENDIMENTO: string | number[];
}) {
    return Service(
        Axios.post<Array<IProduto>>(
            `/home/produtos/listarprodutosporempreendimentos`,
            requestBody
        )
    );
}

export async function ListarBlocosEmpreendimentoService(
    ID_EMPREENDIMENTO: string | number[]
) {
    return Service(
        Axios.post<Array<IBloco>>(
            `/home/produtos/listarblocosempreendimento`,
            ID_EMPREENDIMENTO
        )
    );
}

export async function ListarBlocosEmpreendimentoEmccampService(
    ID_EMPREENDIMENTO: string | number[]
) {
    return Service(
        Axios.post<Array<IBloco>>(
            `/home/produtos/listarblocosempreendimentoemccamp`,
            ID_EMPREENDIMENTO
        )
    );
}

export async function ListarUnidadesService(idProduto: number) {
    const response = await Axios.get<Array<IUnidade>>(
        `/home/produtos/listarunidades?idProduto=${idProduto}`
    )
        .then((response) => {
            return response;
        })
        .catch((err) => {
            throw err.response;
        });
    return response;
}

export async function ListarUnidadesByIdEmpreendimentoService(
    idProduto: number
) {
    const response = await Axios.get<Array<IUnidade>>(
        `/home/produtos/listarunidadesbyidempreendimento?idProduto=${idProduto}`
    )
        .then((response) => {
            return response;
        })
        .catch((err) => {
            throw err.response;
        });
    return response;
}

export async function CadastrarProdutoService(data: ICadastrarProduto) {
    return Service(Axios.post(`/home/produtos/cadastrarproduto`, data));
}

export async function ListarClassificacaoProdutoService() {
    return Service(
        Axios.get<Array<IClassificacaoProduto>>(
            `/home/classificacaoproduto/listarclassificaoproduto`
        )
    );
}

export async function ListarProdutosArvoreService() {
    return Service(
        Axios.get<Array<IProdutosArvore>>(`/home/produtos/listarprodutosarvore`)
    );
}

export async function AtualizarProdutoService(data: ICadastrarProduto) {
    return Service(Axios.put(`/home/produtos/atualizarproduto`, data));
}

export async function ObterFormularioProdutoService(
    idProduto: number,
    flListagemCompleta?: boolean
) {
    return Service(
        Axios.get<ICadastrarFormularioProduto>(
            `/formularioproduto/obterformularioproduto?idProduto=${idProduto}&flListagemCompleta=${
                flListagemCompleta ?? false
            }`
        )
    );
}

export async function CadastrarFormularioProdutoService(
    requestBody: ICadastrarFormularioProduto
) {
    return Service(
        Axios.post(`/formularioproduto/cadastrarformularioproduto`, requestBody)
    );
}

export async function EditarFormularioProdutoService(
    requestBody: ICadastrarFormularioProduto
) {
    return Service(
        Axios.put(`/formularioproduto/editarformularioproduto`, requestBody)
    );
}

export async function DeletarFormularioProdutoService(
    idFormularioProduto: number
) {
    return Service(
        Axios.delete(
            `/formularioproduto/removerformularioproduto?idFormularioProduto=${idFormularioProduto}`
        )
    );
}

export async function ListarPerguntasFormularioProdutoService(
    idFormularioProduto: number
) {
    return Service(
        Axios.get<Array<ICadastrarPerguntaFormularioProduto>>(
            `/formularioproduto/listarperguntasformulario?idFormularioProduto=${idFormularioProduto}`
        )
    );
}

export async function CadastrarPerguntaFormularioProdutoService(
    requestBody: ICadastrarPerguntaFormularioProduto
) {
    return Service(
        Axios.post(
            `/formularioproduto/cadastrarperguntaformulario`,
            requestBody
        )
    );
}

export async function EditarPerguntaFormularioProdutoService(
    requestBody: ICadastrarPerguntaFormularioProduto
) {
    return Service(
        Axios.put(`/formularioproduto/editarperguntaformulario`, requestBody)
    );
}

export async function DeletarPerguntaFormularioProdutoService(
    idFormularioPergunta: number
) {
    return Service(
        Axios.delete(
            `/formularioproduto/deletarpergunta?idFormularioPergunta=${idFormularioPergunta}`
        )
    );
}

export async function ListarRespostasFormularioProdutoService(
    idFormularioPergunta: number
) {
    return Service(
        Axios.get(
            `/formularioproduto/listarrespostasformulario?idFormularioPergunta=${idFormularioPergunta}`
        )
    );
}

export async function CadastrarRespostaFormularioProdutoService(
    requestBody: ICadastrarRespostaFormularioProduto
) {
    return Service(
        Axios.post(
            `/formularioproduto/cadastrarrespostaformulario`,
            requestBody
        )
    );
}

export async function EditarRespostaFormularioProdutoService(
    requestBody: ICadastrarRespostaFormularioProduto
) {
    return Service(
        Axios.put(`/formularioproduto/editarrespostaformulario`, requestBody)
    );
}

export async function DeletarRespostaFormularioProdutoService(
    idFormularioResposta: number
) {
    return Service(
        Axios.delete(
            `/formularioproduto/deletarresposta?idFormularioResposta=${idFormularioResposta}`
        )
    );
}

export async function ListarRespostaFormularioProdutoService(
    idFormularioPergunta: number
) {
    return Service(
        Axios.get(
            `/formularioproduto/listarrespostaescolhidaformulario?idFormularioPergunta=${idFormularioPergunta}`
        )
    );
}

export async function ResponderFormularioProdutoService(
    requestBody: Array<IResponderFormularioProduto>
) {
    return Service(
        Axios.post(`/formularioproduto/responderformulario`, requestBody)
    );
}

export async function DeletarRespostaEnviadaFormularioProdutoService(
    idRespostaFormularioProduto: number
) {
    return Service(
        Axios.delete(
            `/formularioproduto/deletarrespostaenviada?idRespostaFormularioProduto=${idRespostaFormularioProduto}`
        )
    );
}

export async function DeletarRespostasEnviadasFormularioProdutoService(
    idFormularioProduto: number
) {
    return Service(
        Axios.delete(
            `/formularioproduto/deletarrespostasenviadasformulario?idFormularioProduto=${idFormularioProduto}`
        )
    );
}
